import React, { useCallback, useEffect, useState } from "react";
import { Redirect, BrowserRouter as Router, Switch } from "react-router-dom";
import { PublicRouter } from "./PublicRouter";

import { LoginScreen } from "../Screens/Auth/LoginScreen";
import { PrivateRouter } from "./PrivateRouter";
import { MainScreen } from "../Screens/Main/MainScreen";
import { useDispatch, useSelector } from "react-redux";
import { ValidateUserAction } from "../Actions/Auth/LoginAction";
import { types } from "../Helpers/Types";

export const MainRouter = () => {
  const { autenticado } = useSelector((state) => state.sesion);
  const params = new URLSearchParams(window.location.search);
  const origin = params.get("from");
  const parametro = params.get("parametro");

  const dispatch = useDispatch();
  const sesion = useCallback((result, autenticado) => {
    dispatch({
      type: types.sesion,
      payload: {
        autenticado,
        menus: result.menus,
        modulos: result.modulos,
        presas: result.presas,
        roles: result.roles
      },
    });
  }, []);
  useEffect(() => {
    ValidateUserAction()
      .then((result) => {
        dispatch({
          type: types.usuario,
          payload: {
            empleado: result.usuario.empleado,
            idempleado: result.usuario.idempleado,
            sucursal: result.usuario.sucursal,
            departamento: result.usuario.departamento,
            puesto: result.usuario.puesto,
            adr: result.usuario.adr,
            token: result.token,
          },
        });
        sesion(result, true);

      })
      .catch((error) => {
        sesion(
          {
            menus: [],
            modulos: [],
            presas: [],
          },
          false
        );
        // Swal.fire("HUMAYA  DIGITAL", JSON.stringify(error), "error");
      });
  }, []);
  // return <div> Prueba de Push</div>
  if (autenticado === undefined || autenticado === null) {
    return <div> Loading...</div>;
  } else {
    // return (
    //   <div>
    //     {JSON.stringify(origin)}
    //     {JSON.stringify(parametro)}
    //   </div>
    // );
  }
  return (
    <Router>
      <Switch>
        <PublicRouter
          Autenticado={autenticado}
          origin={origin}
          path={`/auth/login`}
          component={LoginScreen}
        />
        <PrivateRouter
          Autenticado={autenticado}
          path={`/`}
          component={MainScreen}
        />
        <Redirect to={`/auth/login`} />
      </Switch>
    </Router>
  );
};
